import { Table } from '@tanstack/react-table';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

import { EventRulesTableFacedFilter } from './event-rules-table-faceted-filter.tsx';
import {
  EventRule,
  eventRuleStatuses,
} from '@/features/event-rules/schemas/event-rules.schema.ts';
import { CreateEventRule } from '@/features/event-rules/components/create-event-rule/create-event-rule.tsx';
import { Cross2Icon } from '@radix-ui/react-icons';
import { EventRulesTableToolbarDeleteDialog } from '@/features/event-rules/components/event-rules-table/event-rules-table-toolbar-delete-dialog.tsx';
import { EventRulesTableToolbarEditDropdown } from '@/features/event-rules/components/event-rules-table/event-rules-table-toolbar-edit-dropdown-menu.tsx';

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
}

export function EventRulesTableToolbar<TData extends EventRule>({
  table,
}: DataTableToolbarProps<TData>) {
  const isFiltered = table.getState().columnFilters.length > 0;

  return (
    <div className="flex justify-between gap-4">
      <div className="flex flex-1 flex-col flex-wrap gap-2 sm:flex-row">
        <Input
          placeholder="Filter event rules by title..."
          value={(table.getColumn('eventTitle')?.getFilterValue() as string) ?? ''}
          onChange={(event) =>
            table.getColumn('eventTitle')?.setFilterValue(event.target.value)
          }
          className="h-8 w-full max-w-[250px] bg-white"
        />
        {table.getColumn('status') && (
          <EventRulesTableFacedFilter
            column={table.getColumn('status')}
            title="Status"
            options={eventRuleStatuses}
          />
        )}
        {isFiltered && (
          <Button
            variant="ghost"
            onClick={() => table.resetColumnFilters()}
            className="h-8 w-min px-2 lg:px-3"
          >
            Reset
            <Cross2Icon className="ml-2 h-4 w-4" />
          </Button>
        )}
      </div>
      <div className="flex flex-col gap-2 sm:flex-row">
        <div className="order-2 flex flex-wrap gap-2 sm:order-0">
          {table.getFilteredSelectedRowModel().rows.length > 0 ? (
            <EventRulesTableToolbarEditDropdown
              eventRules={table.getFilteredSelectedRowModel().rows.map((row) => row.original)}
              onSuccess={() => table.toggleAllRowsSelected(false)}
            />
          ) : null}
          {table.getFilteredSelectedRowModel().rows.length > 0 ? (
            <EventRulesTableToolbarDeleteDialog
              eventRules={table.getFilteredSelectedRowModel().rows.map((row) => row.original)}
              onSuccess={() => table.toggleAllRowsSelected(false)}
            />
          ) : null}
        </div>
        {/*<EventRulesTableViewOptions table={table} />*/}
        <CreateEventRule />
      </div>
    </div>
  );
}
